export default function({ dispatch, commit }, params) {
    // POST /auth/change/password
    return dispatch('post', {
        url: '/auth/change/password',
        data: params
    }, {
        root: true
    })
    .then((response) => {
        return response
    })
    .catch((error) => {
        return error
    })
}
